import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import '@cigna/cigna_csg_gsg_cipublic-spinner/cipublic-spinner.js';
import styles from './placeholder.scss.js';
/**
 * @element cipublic-placeholder
 */
export class Placeholder extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * myProp description
         */
        this.variant = 'default';
        this.background = 'alternate';
    }
    render() {
        return html `<cipublic-spinner slot="loading" variant="small"><span><slot name="loading-label"></slot></span></cipublic-spinner>`;
    }
}
Placeholder.styles = styles;
__decorate([
    property({ reflect: true })
], Placeholder.prototype, "variant", void 0);
__decorate([
    property({ reflect: true })
], Placeholder.prototype, "background", void 0);
//# sourceMappingURL=placeholder.js.map